import { useClearFlowBranding } from "./use-clear-flow-branding";
import { useClearFlowCrisp } from "./use-clear-flow-crisp";

/**
 * Router-level side effects for the clear flow: hides support chat and strips
 * the Blueticks tab title/favicon. Renders nothing.
 *
 * Lives inside the router (not in AppView) because it must also cover the clear
 * AUTH screens — /clear-login and friends render LoginView directly, with no
 * AppView around them.
 */
export default function ClearFlowChrome() {
  useClearFlowCrisp();
  useClearFlowBranding();
  return null;
}
